import { SVGProps } from "react";

export function Facebook(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.0813 1.09888H1.92001C1.46921 1.09888 1.10376 1.46432 1.10376 1.91513V15.0764C1.10376 15.5272 1.46921 15.8926 1.92001 15.8926H15.0813C15.5321 15.8926 15.8975 15.5272 15.8975 15.0764V1.91513C15.8975 1.46432 15.5321 1.09888 15.0813 1.09888Z"
        fill="#3D5A98"
      />
      <path
        d="M11.31 15.8915V10.1627H13.2325L13.52 7.93023H11.31V6.50523C11.31 5.85898 11.49 5.41773 12.4163 5.41773H13.5988V3.41773C13.0261 3.35816 12.4507 3.32978 11.875 3.33273C10.1725 3.33273 9.00001 4.37023 9.00001 6.28398V7.93023H7.07751V10.1627H9.00001V15.8915H11.31Z"
        fill="white"
      />
    </svg>
  );
}
